define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Model = require('backbone').Model;
    var DropDownEditableView = require('common/dropdown.editable/dropdown.editable.view');

    module.exports = DropDownEditableView.extend({

        events: {
            'change .fn-input-text': 'onInputTextChange',
            'change .fn-select': 'onSelectChange',
            'input .fn-input-text': 'onInputTextInput',
        },

        initialize: function(options) {
            this.options = _.extend({}, this.options, options);

            this.model = new Model({
                value: this.options.value != null ? this.options.value : '',
                counterValue: 0
            });

            this.setDataList(this.options);
            this.setDisplayValuesMap(this.options);

            this.options._enableTextInput = this.options.mode !== 'list';
            this.options._enableSelect = this.options.mode !== 'text';

            this.el.classList.toggle('list', this.options._enableSelect);
        },

        onInputTextInput: function(e) {
            const oldValue = this.options.value;
            var newValue = e.currentTarget.value;
            var countedValue;
            var precision = newValue?.includes('.') ? Math.min(newValue.split('.')[1]?.length, 2) : 0 ;
            var calculatedValue = (newValue - oldValue).toFixed(precision);
            var spanCalculatedText = this.$counterValue[0];

            switch (true) {
                case isNaN(calculatedValue):
                    countedValue = '';
                    break;
                case calculatedValue > 0:
                    countedValue = `+${calculatedValue}`;
                    break;
                default:
                    countedValue = calculatedValue;
                    break;
            }

            spanCalculatedText.innerText = countedValue;
        },

        onOptionsChange: function(e) {
            var options = e.payload;
            if (!options) {
                return;
            }

            if ('value' in options) {
                this.model.set('value', options.value);
            }

            if ('counterValue' in options) {
                this.model.set('counterValue', options.counterValue);
            }

            if ('dataList' in options) {
                this.setDataList(options);
            }

            if ('displayValuesMap' in options) {
                this.setDisplayValuesMap(options);
            }

            if ('disabled' in options) {
                this.setDisabled(options);
            }

            this.updateSelectOptions();
            this.updateInputValues();
        },

        //endregion

        setModelValueFromInput: function(e) {
            var value = e.target.value;
            var isSame = value === this.model.get('value');
            var valueFromDisplayValue = this.getValueFromDisplayValue(value);
            var precision = valueFromDisplayValue?.includes('.') ? Math.min(valueFromDisplayValue.split('.')[1]?.length, 2) : 0 ;
            var counterValue = (valueFromDisplayValue - this.options.value).toFixed(precision);
            this.model.set({
                'value': this.getValueFromDisplayValue(value),
                'counterValue': counterValue
            });

            if (isSame) {
                this.model.trigger('change:value');
            }
        },

        updateInputValues: function() {
            var value = this.model.get('value');
            var valueToSend = value;
            var counterValue = this.model.get('counterValue');

            if (this.options.inputMode === 'decimal') {
                valueToSend = String(value).replace(',', '.');
            }

            this.$value.val(valueToSend);
            this.$counterValue.val(counterValue);
            this.$input.val(this.getDisplayValue(value));
            this.$select.val(this.getDisplayValue(value));
        },

        getRenderOptions: function() {
            return _.extend({}, this.options, {
                inputTextValue: this.getDisplayValue(this.model.get('value')),
                counterValue: this.getDisplayValue(this.model.get('counterValue'))
            });
        },

        render: function() {
            this.$el.html(this.tmpl(this.options.template, this.getRenderOptions()));

            this.$value = this.$('.fn-input-hidden');
            this.$counterValue = this.$('.input-counter');
            this.$input = this.$('.fn-input-text');
            this.$select = this.$('.fn-select');
            this.$select.val(this.model.get('value'));

            return this;
        }
    });
});
